import React, { useState } from "react";
import PopupWrapper from "../../../components/PopupWrapper";
import moment from "moment";
import { toast } from "react-toastify";
import { commonToast } from "../../../Utils";
import { useSelector } from "react-redux";
import urls from "../../../Utils/urls";
import axios from "axios";
import { LoadingButton } from "../../../Utils/CustomComponent";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
  maxBodyLength: Infinity,
};

export const ForeClosureLoanModal = ({
  onClose, // Function passed by parent to handle closing
  onCreateTicket, // Function passed by parent to redirect/handle ticket creation
  show = true,
  showClose = false,
  foreclosureLoan = null,
  loanRecid = null,
  isRoc = false,
}) => {
  const [loading, setLoading] = useState(false);
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));

  const handleCreateTicket = () => {
    setLoading(true);
    const id = toast.loading("Creating a new ticket");

    const payload = {
      user_id: `${userDetails.user_id}`,
      contact_email: userDetails.email,
      status_id: "1",
      role_type: "B",
      severity_id: "",
      urgency_id: "",
      department_id: "1",
      category_id: "1",
      subject: "Payment Request for a Loan in Foreclosure",
      incident_description: `Borrower request to process a payment for a loan in foreclosure (${foreclosureLoan})`,
      account: loanRecid,
    };

    axios
      .post(urls.support.postTicket(), payload, { headers })
      .then((response) => {
        toast.update(id, {
          render: "Ticket Created",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
        setLoading(false);
        onClose();
      })
      .catch((error) => {
        console.error(error);
        toast.update(id, {
          render: "SOME ERROR OCCURED",
          type: "error",
          isLoading: false,
          ...commonToast,
        });
        setLoading(false);
      });
  };

  return (
    <div>
      <PopupWrapper
        title={
          <h5 className="modal-title text-black">
            <span role="img" aria-label="alert">
              ⚠️
            </span>{" "}
            LOAN IN FORECLOSURE - ACTION REQUIRED
          </h5>
        }
        extraClass="width-800"
        titleClassName="text-white px-5"
        headerClassName="bg-error"
        Component={
          <div>
            <div>
              {/* Core Message */}
              <div className="alert alert-error p-3 mb-4" role="alert">
                <h4 className="alert-heading">
                  <span role="img" aria-label="stop" className="mr-2">
                    🛑{" "}
                  </span>
                  PAYMENT CANNOT BE PROCESSED VIA THIS ONLINE PORTAL.
                </h4>
              </div>

              {/* 5. Contact Instructions */}
              {/* <p
                className="mt-5"
                style={{ fontWeight: "bold", marginBottom: "10px" }}
              >
                Next Steps:
              </p> */}

              <ul
                style={{
                  listStyleType: "disc",
                  marginLeft: "20px",
                  marginBottom: "30px",
                }}
              >
                {/* <li>**Management Company:** {managementCompany}</li>
                <li>**Phone:** {contactPhone}</li>
                <li>**Email:** info@superiorloanservicing.com</li> */}
                <li>
                  Unfortunately you will not be able to make a payment for loan{" "}
                  <span className="fw-bold">{foreclosureLoan}</span> at this time as your loan is in
                  the foreclosure process. For further assistance please call
                  Customer Service at 888-587-9757 for assistance.
                </li>
              </ul>
            </div>
            <div
              className={`modal-footer justify-content-${
                showClose ? "end" : "center"
              }`}
            >
              {showClose && (
                <button
                  type="button"
                  className="btn btn-secondary btn-lg border"
                  onClick={onClose}
                >
                  Close
                </button>
              )}
              <LoadingButton
                loading={loading}
                disabled={loading}
                onClick={handleCreateTicket}
                className="btn btn-primary btn-lg"
                title={"Open a Ticket"}
              />
            </div>
          </div>
        }
        toShow={show}
        closeEventHandler={onClose}
        backdrop="static"
        closeButton={false}
      />
    </div>
  );
};
